import { createFileRoute } from '@tanstack/react-router'
import PlanRenameModalWrapper from '../../../../../../containers/plan-menu/components/rename-modals/plan-wrapper'
import PlanFoldersRenameModalWrapper from '../../../../../../containers/plan-menu/components/rename-modals/plan-folders-wrapper'
import { plansRenameSearchSchema } from '../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans/rename/'
)({
  component: RouteComponent,
  validateSearch: plansRenameSearchSchema
})

function RouteComponent() {
  const { type } = Route.useSearch()

  return type === 'folder' ? (
    <PlanFoldersRenameModalWrapper />
  ) : (
    <PlanRenameModalWrapper />
  )
}
